import {bindable, computedFrom, autoinject} from 'aurelia-framework';
import {IMeasureInputAM, IMeasureInputRuleReferenceAM} from "../../services/measure-service";
import { ResourceService } from '../../../../utils/resourceService';

@autoinject
export class MeasureLabel {

	@bindable measureInput: IMeasureInputAM;
	@bindable ruleReferenceInfo: IMeasureInputRuleReferenceAM;

	constructor(private resources: ResourceService) { }

	@computedFrom('ruleReferenceInfo')
	get ruleReferenceInfoText(): string {
		
		if (!this.ruleReferenceInfo) { return null; }

		return this.resources.getResource('MeasuresInputContainer_MeasureLabel_RuleDescriptionPrefix')
			+ "<br />"
			+ this.ruleReferenceInfo.description.replace("\n", "<br />");
	}
}
